<!-- @format -->

<template>
  <div class="card">
    <ul style="list-style-type: none;background-color: #696969;margin:0">
      <li v-for="(item, index) in treeData" :key="index" style="margin:0 !important">
        <div class="item" :class="{ 'line-left': index !== 0, 'line-right': index != treeData.length - 1, }">
          <div
            class="item-name " :class="{ 'line-bottom': item.child && item.child.length > 0, 'line-top': !treeFirst, }"
            :style="{background: getColor(item),color: '#000',fontWeight:'bold',fontSize: '18px'}"
          >
            <div style="white-space: nowrap;">
              <!-- <img :src="item.avatar" alt="" style="width: 30px"> -->
              <b-avatar :size="30" :src="item.avatar" :rounded="true" class="mr-1" />
              <!-- {{ item.name || item.real_name }} -->
              {{ item.id }}
            </div>
          </div>
        </div>
        <tree-item v-if="item.child && item.child.length > 0" :tree-data="item.child" :tree-level="treeLevel" />
      </li>
    </ul>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'

export default {
  name: 'TreeItem',
  components: { BAvatar },
  props: {
    treeData: {
      type: Array,
      default: () => [],
    },
    treeFirst: {
      type: Boolean,
      default: false,
    },
    treeLevel: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getColor(item) {
      return this.treeLevel.find(items => item.level.id === items.id).color
    },
  }
}
</script>

<style lang="scss" scoped>
$line-length: 20px; //线长
$spacing: 20px; //间距
$extend: calc(#{$spacing} + 2px); //延长线

// 线样式
@mixin line {
  content: "";
  display: block;
  width: 3px;
  height: $line-length;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  background: rgb(255,255,255);
}
// 加减号icon
@mixin icon {
  position: absolute;
  border: solid 1px #666;
  border-radius: 100%;
  bottom: -5px;
  width: 12px;
  height: 12px;
  line-height: 10px;
  text-align: center;
  color: #666;
  z-index: 100;
  cursor: pointer;
  margin: 0;
  padding: 0;
  // opacity: 0;
}

.card {
  height: inherit;
  // overflow: hidden;
  ul {
    display: flex;
    justify-content: center;
    padding: 0;
    height: 100%;
    li {
      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        &-name {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 50px;
          padding: 5px;
          margin: $spacing;
          background: coral;
          color: #fff;
          min-width: max-content;
          .plus {
            @include icon();
            &:hover {
              opacity: 100%;
            }
          }
          .reduce {
            @include icon();
            top: -5px;
            &:hover {
              opacity: 100%;
            }
          }
        }
      }
    }
  }
  // 向下的线
  .line-bottom {
    &::after {
      @include line();
      bottom: -$line-length;
    }
  }
  // 向上的线
  .line-top {
    &::before {
      @include line();
      top: -$line-length;
    }
  }
  // 向左的线
  .line-left {
    &::after {
      @include line();
      width: calc(50% + #{$spacing});
      height: 3px;
      left: calc(-50% - #{$extend});
      top: 0;
    }
  }
  // 向右的线
  .line-right {
    &::before {
      @include line();
      width: calc(50% + #{$spacing});
      height: 3px;
      right: calc(-50% - #{$extend});
      top: 0;
    }
  }
}
</style>
